// やさまるシフト 用語マップ・選択肢定義
// 内部値は既存DBと互換維持 (available/either/unavailable)

import { CircleCheck, Circle, X } from "lucide-react";

// 区分（リクエストタイプ）の表示
export const REQUEST_TYPE_LABELS = {
  available: {
    value: "available",
    label: "◎ 入れます",
    shortLabel: "◎",
    description: "シフトに入って大丈夫な日",
    color: "bg-emerald-50 text-emerald-700 border-emerald-300",
    chipColor: "bg-emerald-100 text-emerald-800 border-emerald-300",
    icon: CircleCheck,
  },
  either: {
    value: "either",
    label: "○ 必要なら入れます",
    shortLabel: "○",
    description: "人が少ない時なら入れる日 (お願い候補)",
    color: "bg-sky-50 text-sky-700 border-sky-300",
    chipColor: "bg-sky-100 text-sky-800 border-sky-300",
    icon: Circle,
  },
  unavailable: {
    value: "unavailable",
    label: "× 入れません",
    shortLabel: "×",
    description: "出勤できない日",
    color: "bg-rose-50 text-rose-700 border-rose-300",
    chipColor: "bg-rose-100 text-rose-800 border-rose-300",
    icon: X,
  },
};

export const REQUEST_TYPE_ORDER = ["available", "either", "unavailable"];

export const PERIOD_STATUS_LABELS = {
  accepting: "提出受付中",
  adjusting: "調整中",
  confirmed: "確定済",
  published: "公開済",
  closed: "終了",
};

// シフト作成フローの5ステップ
export const SHIFT_STEPS = [
  { id: 1, key: "prep-month", label: "今月の準備", short: "準備" },
  { id: 2, key: "magic", label: "配置マジック", short: "マジック" },
  { id: 3, key: "adjust-day", label: "日を調整する", short: "日調整" },
  { id: 4, key: "staff-review", label: "スタッフ別設定状況", short: "スタッフ" },
  { id: 5, key: "publish", label: "確定する", short: "確定" },
];

export const pad = (n) => String(n).padStart(2, "0");
export const wdLabel = (wd) => ["日", "月", "火", "水", "木", "金", "土"][wd];
export const wdColor = (wd) => wd === 0 ? "text-red-500" : wd === 6 ? "text-blue-500" : "text-slate-700";

// 配置の選択肢 (フォールバック。APIから取得が基本)
export const ASSIGNMENT_OPTIONS = [
  "ホール",
  "キッチン",
  "レジ",
  "仕込み",
  "洗い場",
  "配送",
  "ピッキング",
  "事務",
];

// 外す理由
export const REMOVAL_REASONS = [
  "希望日数より多かったため",
  "上限に近かったため",
  "他のスタッフを優先するため",
  "前回少なかった人を優先するため",
  "全体バランス調整のため",
  "その他",
];

// スタッフの状態ラベル判定 (削る画面のステータス)
export function deriveTrimLabel(sm) {
  if (sm.prev_month_was_under) {
    return { label: "前回少なめ → できれば残したい", tone: "blue" };
  }
  if (sm.diff_vs_desired !== null && sm.diff_vs_desired !== undefined) {
    if (sm.diff_vs_desired > 1) return { label: `希望より${sm.diff_vs_desired}日多め → 削る候補`, tone: "purple" };
    if (sm.diff_vs_desired === 1) return { label: "希望より1日多め", tone: "slate" };
    if (sm.diff_vs_desired === 0) return { label: "希望通り → できれば残したい", tone: "green" };
    if (sm.diff_vs_desired < 0) return { label: `希望より${-sm.diff_vs_desired}日少なめ → 残したい`, tone: "blue" };
  }
  return { label: "標準", tone: "slate" };
}

// 候補スタッフの状態ラベル判定 (Step2/Step3 候補一覧用)
export function deriveCandidateLabel(c) {
  const labels = [];
  if (c.request_type === "unavailable") labels.push({ label: "× 出勤不可", tone: "red" });
  if (c.weekly_days_until_max !== null && c.weekly_days_until_max !== undefined && c.weekly_days_until_max <= 0)
    labels.push({ label: "週上限超過", tone: "red" });
  else if (c.weekly_days_until_max !== null && c.weekly_days_until_max !== undefined && c.weekly_days_until_max <= 1)
    labels.push({ label: "週上限に近い", tone: "orange" });
  if (c.days_until_max !== null && c.days_until_max !== undefined && c.days_until_max <= 0)
    labels.push({ label: "月上限超過", tone: "red" });
  else if (c.days_until_max !== null && c.days_until_max !== undefined && c.days_until_max <= 1)
    labels.push({ label: "月上限に近い", tone: "orange" });
  if (c.consecutive_streak_if_assigned >= 5)
    labels.push({ label: `連勤${c.consecutive_streak_if_assigned}日`, tone: "orange" });
  if (c.diff_vs_desired !== null && c.diff_vs_desired !== undefined) {
    if (c.diff_vs_desired < 0) labels.push({ label: `希望より${-c.diff_vs_desired}日少なめ`, tone: "blue" });
    else if (c.diff_vs_desired > 1) labels.push({ label: `希望より${c.diff_vs_desired}日多め`, tone: "purple" });
  }
  if (c.prev_month_was_under) labels.push({ label: "前回少なめ", tone: "blue" });
  if (labels.length === 0) labels.push({ label: "入れやすい", tone: "green" });
  return labels;
}
